import type { Translator } from '@/i18n';

interface Props {
  t: Translator['t'];
  kind: 'denied' | 'unavailable';
  onRetry: () => void;
  onDismiss: () => void;
}

/**
 * Пояснення, коли доступ до камери й мікрофона не отримано.
 *
 * Формулювання — браузерні: у вебі немає ані налаштувань застосунку, ані
 * способу відкрити їх програмно. У ARB для цього є окрема пара ключів
 * (`mediaPermissionsRequired` / `browserSettings` проти мобільних
 * `...Mobile` / `openAppSettings`) — беремо саме браузерну гілку.
 */
export function PermissionNotice({ t, kind, onRetry, onDismiss }: Props): React.JSX.Element {
  return (
    <div className="overlay" role="dialog" aria-modal="true">
      <div className="card">
        <div className="card__inner">
        <h2>{t('permissionsRequired')}</h2>
        <p>{kind === 'denied' ? t('mediaPermissionsRequired') : t('permissionsNotGranted')}</p>
        <p>{t('browserSettings')}</p>
        <ul className="notice__list">
          <li>
            <strong>{t('camera')}</strong> — {t('cameraDescription')}
          </li>
          <li>
            <strong>{t('microphone')}</strong> — {t('microphoneDescription')}
          </li>
        </ul>
        <div className="card__actions">
          <button type="button" className="button button--ghost" onClick={onDismiss}>
            {t('cancel')}
          </button>
          <button type="button" className="button button--primary" onClick={onRetry}>
            {t('grantPermissions')}
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
